import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import momencik from '../../../common/momencik';
import { GetInvoicePaymentDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import mathUtils from '../../../utils/mathUtils';
import numberFormatter from '../../../common/numberFormatter';

interface InvoicePaymentsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  withFilterInColumns?: boolean;
  showFilter?: boolean;
  showExport?: boolean;
}

export const invoicePaymentForGrid = (
  payment: GetInvoicePaymentDto,
): GridRecord => {
  return {
    key: payment.id,
    values: {
      id: payment.id,
      'invoicePayment.systemNumber': payment.systemNumber,
      'invoicePayment.amount': numberFormatter(
        payment.amount ? mathUtils.parse(payment.amount) : null,
        true,
      ),
      'invoicePayment.paymentDate': momencik(payment.paymentDate, 'YYYY-MM-DD'),
      'paymentCollection.name': payment.paymentCollection?.name || '',
      'paymentCollection.systemNumber':
        payment.paymentCollection?.systemNumber || '',
      'invoicePayment.unlinkedAmount':
        numberFormatter(
          payment.unlinkedAmount !== null &&
            payment.unlinkedAmount !== undefined
            ? mathUtils.parse(payment.unlinkedAmount)
            : null,
          true,
        ) || '0,00 zł',
      'invoicePayment.sender': payment.sender || '',
      'invoicePayment.title': payment.title || '',
      linkedDocuments: payment.linkedDocuments || '',
    },
    isInactive: !payment.active,
    tdCssClass: {
      'invoicePayment.amount': 'amounts-align-right',
      'invoicePayment.unlinkedAmount': 'amounts-align-right',
    },
  };
};

export const InvoicePaymentsSearch: React.FC<
  InvoicePaymentsSearchProps
> = props => {
  const columns: GridColumn[] = [
    { header: 'Nr sys.', property: 'invoicePayment.systemNumber' },
    { header: 'Kwota', property: 'invoicePayment.amount' },
    {
      header: 'Kwota niedowiązana',
      property: 'invoicePayment.unlinkedAmount',
      noFilter: true,
      noSorting: true,
    },
    { header: 'Data wpłaty', property: 'invoicePayment.paymentDate' },
    { header: 'Nadawca', property: 'invoicePayment.sender' },
    { header: 'Tytuł', property: 'invoicePayment.title' },
    {
      header: 'Powiązane dokumenty',
      property: 'linkedDocuments',
      noSorting: true,
    },
    {
      header: 'Nazwa zbioru wpłat',
      property: 'paymentCollection.name',
    },
    {
      header: 'Nr sys. zbioru wpłat',
      property: 'paymentCollection.systemNumber',
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={props.showFilter}
      initialOrderColumn="invoicePayment.systemNumber"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={'Brak wpłat w systemie'}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={true}
      withFilterInColumns={props.withFilterInColumns}
      showExport={props.showExport}
    />
  );
};
